import { Company } from "@kanda-libs/ks-frontend-services";

export interface FormattedCompanyDetails {
  name: string;
  email: string;
  phone: string;
  address: string;
}

export const formatCompany = (company?: Company): FormattedCompanyDetails => {
  const name =
    company?.company_type === "limited_company"
      ? company?.limited_company_info?.company_name
      : company?.sole_trader_info?.trading_name;
  const addr =
    company?.company_type === "limited_company"
      ? company?.limited_company_info?.company_address
      : company?.sole_trader_info?.trading_address;
  const address = [addr?.line_1, addr?.line_2, addr?.city, addr?.postcode]
    .filter(Boolean)
    .join(", ");
  return {
    name: name || "No name provided",
    email: company?.contact_info?.contact_email || "No email added",
    phone: company?.contact_info?.contact_phone || "No phone added",
    address: address || "No address added",
  };
};
